import type { FeatureConfigValue, PageId } from 'src/app/featureToggle/types';

export const pageRolloutStrategy = (
  currentPage: PageId,
  value: FeatureConfigValue,
): boolean => {
  if (!value) return false;

  // If "enabled" is specifically "false" then none of the other rules apply
  if (value.enabled === false) return false;

  // Otherwise, check if a feature is enabled for the currently open page
  if (value.pages && value.pages[currentPage]) {
    return Boolean(value.pages[currentPage]);
  }

  // Otherwise if "enabled" is true then use it, else return false
  return Boolean(value.enabled);
};
